// src/lib/inventory.js
import api from "./api";

const asArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

export async function listProducts() {
  const { data } = await api.get("/b/products");
  return asArray(data);
}

export async function createProduct(payload) {
  const { data } = await api.post("/b/products", payload);
  return data;
}

export async function patchProduct(productId, payload) {
  if (!productId) throw new Error("Missing productId");
  const { data } = await api.patch(`/b/products/${productId}`, payload);
  return data;
}

export async function listStockLevels({ locationId } = {}) {
  const params = {};
  if (locationId) params.location_id = locationId;
  const { data } = await api.get("/b/stock-levels", { params });
  return asArray(data);
}

export async function listStockMovements({
  productId,
  locationId,
  from,
  to,
  limit = 50,
} = {}) {
  const params = { limit };
  if (productId) params.product_id = productId;
  if (locationId) params.location_id = locationId;
  if (from) params.from = from;
  if (to) params.to = to;
  const { data } = await api.get("/b/stock-movements", { params });
  return asArray(data);
}

export async function receiveStock(payload) {
  const { data } = await api.post("/b/stock/receive", payload);
  return data;
}

export async function adjustStock(payload) {
  const { data } = await api.post("/b/stock/adjust", payload);
  return data;
}

export async function getServiceConsumables(serviceId) {
  if (!serviceId) throw new Error("Missing serviceId");
  const { data } = await api.get(`/b/services/${serviceId}/consumables`);
  return asArray(data);
}

export async function setServiceConsumables(serviceId, items) {
  if (!serviceId) throw new Error("Missing serviceId");
  const { data } = await api.put(
    `/b/services/${serviceId}/consumables`,
    Array.isArray(items) ? items : []
  );
  return data;
}

export async function getProfitReport({ from, to, groupBy = "month" } = {}) {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (groupBy) params.group_by = groupBy;
  const { data } = await api.get("/b/reports/profit", { params });
  return data;
}
